import { Button, Typography } from '@material-ui/core';
import React, { useContext } from 'react';
import { URLContext } from '../../contexts/URLContext';
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';

const BGError = styled.div`
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.95);
`;

const ErrorContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 550px;
`;

const Image = styled.img`
  max-width: 100px;
  margin: 16px;
`;

const ErrorScreen = (props) => {
  const {baseURL, campaignData} = useContext(URLContext);

  return(
    <BGError>
      <ErrorContainer>
        <Image src={`${baseURL}${campaignData.imgError}`} alt="Ocorreu um erro" />
        <Typography variant="body1" align="center" className="bold-text">
          {ReactHtmlParser(props.children)}
        </Typography>
        {props.button && (
          <Button
            className="white--text bold-text"
            variant="contained"
            color="secondary"
            style={{ width: "80%", marginTop: 16 }}
            onClick={props.target}
            >
            {props.button}
          </Button>
        )}
      </ErrorContainer>
    </BGError>
  );
};

export default ErrorScreen;